import React from 'react';
import { Table } from 'reactstrap';
import { useTranslator, formatCalories } from '@front-activerse/common-components';

interface IDayplanNutritions {
  kcal: number;
  macro: any;
}

export const DayplanNutritions: React.FC<IDayplanNutritions> = ({ kcal, macro }) => {
  const { t } = useTranslator();

  return (
    <div className="table-wrapper">
      <Table>
        <thead>
          <tr>
            <th></th>
            <th className="text-end">{t('mealDetails.macrosTable.wholeMeal')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">{t('mealDetails.macros.calories.title')}</th>
            <td className="text-end">{formatCalories(kcal)} kcal</td>
          </tr>
          <tr>
            <th scope="row">{t('mealDetails.macrosTable.proteins.title')}</th>
            <td className="text-end">{macro.protein.grams} g</td>
          </tr>
          <tr>
            <th scope="row">{t('mealDetails.macrosTable.fats.title')}</th>
            <td className="text-end">{macro.fat.grams} g</td>
          </tr>
          <tr>
            <th>{t('mealDetails.macrosTable.carbs.title')}</th>
            <td className="text-end">{macro.carbohydrates.grams} g</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default DayplanNutritions;
